  <template>
  <div class="video-box">
    <!-- <video id="myVideo" class="video-js">
      <source src="http://vfx.mtime.cn/Video/2019/03/21/mp4/190321153853126488.mp4" type="video/mp4">
    </video> -->
    <div class="v-wrap">
      
    
    <video id="myVideo" class="video-js vjs-default-skin" controls="" preload="auto" x5-playsinline="" playsinline=""
      webkit-playsinline="" poster="" x-webkit-airplay="allow" style='width: 100%;height: auto'>
      <source src="" type="video/mp4">
      
    </video>
    </div>
    <span class="v-all-screen">全屏</span>
  </div>
</template>

<script>
import VideoJs from 'video.js'

export default {
  name: "TestTwo",
  data () {
    return {};
  },
  mounted () {
    this.initVideo();
  },
  methods: {
    initVideo () {
      //初始化视频方法
      let myPlayer = VideoJs(myVideo, {
        bigPlayButton: true, //是否显示播放按钮（这个播放按钮默认会再左上方，需用CSS设置居中）
        textTrackDisplay: true,
        posterImage: true,
        errorDisplay: true,
        controlBar: true,
        autoplay: true,//这个说是自动播放，但是本人使用无效
        controls: true
      }, function () {
        this.play()
      })
//       myPlayer.enterFullScreen();
    },
  requestFullScreen(elem){
    if(elem.requestFullscreen){
      //3c
      
    }else if(elem.mozRequestFullScreen){
      //火狐
    }else if(elem.msRequestFullscreen){
      //MSIE
    }
  }

  }
};
</script>

<style scoped>
.video-box {
  top: 0;
  /* position: fixed; */
  display: flex;
  position: fixed;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 20;
  width: 100%;
  justify-content: center;
  align-items: center;
}
.vjs-big-play-button {
  left: 50% !important;
  top: 50% !important;
  margin-top: -1em;
  margin-left: -1.5em;
}
.video-js .vjs-tech {
  position: static;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.v-all-screen{
  color:red;
  font-size: 20px;
}
</style>